<template>
    <v-btn-toggle
        rounded="0"
        color="primary"
        mandatory
        v-if="translation"
       
    >  
        <v-btn v-for="(url, locale) in translation"
             icon 
             variant="text" 
             :class="(locale == currentLoc) ? 'bordered border-primary' : null" 
             :key="locale+'flag-change-plain'" 
             :id="locale+'flag-change-id-plain'" 
             @click="changeLocale(locale)"
             :href="url"
           >
            <v-icon>
                <country-flag v-if="locale=='en'" country='gb' size='small'/>
                <country-flag v-else :country='locale' size='small'/>
            </v-icon>
        </v-btn>
    </v-btn-toggle>
</template>

<script setup>
    import CountryFlag from 'vue-country-flag-next'
</script>


<script>
import { mapGetters } from 'vuex';
var currentUrl = window.location.href.split('?')[0];

export default {
    name: 'localeChooser',
    computed:{
        ...mapGetters({
            page: 'pages/single',
        })
    },
    data: () => ({
        translation: {
           it: currentUrl+'?lang=it',
           en: currentUrl+'?lang=en',
        },
        currentLoc: '',
    }),
    mounted(){
        this.currentLoc = this.$vuetify.locale.current

        if(this.page){
            if(this.page.translated_slugs){
                this.translation = this.page.translated_slugs;
            }else{
                var url = window.location.href.split('?')[0];
                this.translation = {
                    'it': url+'?lang=it',
                    'en': url+'?lang=en'
                };
            }
        }
    },
    watch:{
        'page.translated_slugs': {
            handler: function(translated_slugs) {
                if(translated_slugs){
                    this.translation = translated_slugs;
                }else{
                    var url = window.location.href.split('?')[0];
                    this.translation = {
                        'it': url+'?lang=it',
                        'en': url+'?lang=en'
                    };
                }
            },
            deep: true
        },
        $route (){
            var url = window.location.href.split('?')[0];
            this.translation = {
                'it': url+'?lang=it',
                'en': url+'?lang=en'
            };
        }
    },
    methods:{
        changeLocale(locale){
            this.currentLoc = locale
            localStorage.setItem('locale',locale);
            this.$vuetify.locale.current = locale
        }
    }
}
</script>